import React, { ReactNode } from 'react';
import { t } from '../../../utils/helpers';
import { useTournamentBanner } from '../hooks/useTournamentBanner';
import { TourneyTimer } from '@base/features/tournaments/components/tourneyTimer';
import styles from '../styles/tournamentBanner.module.scss';

function TournamentBanner() {
  const {
    showBanner,
    startTime,
    directorName,
    rules,
    entryFee,
    time,
  } = useTournamentBanner();

  if (!showBanner) return null;

  return (
    <div className={styles.tournamentBanner}>
      <TournamentBannerItem title={t('tournament')}>
        {startTime}
      </TournamentBannerItem>
      <TournamentBannerItem title={`${t('by')} ${directorName}`}>
        {rules}
      </TournamentBannerItem>
      <TournamentBannerItem title={t('entry_fee')}>
        {entryFee}
      </TournamentBannerItem>
      <TournamentBannerItem title={t('starts_in')}>
        {time && <TourneyTimer timeStart={time} />}
      </TournamentBannerItem>
    </div>
  );
}

const TournamentBannerItem = (props: {
  title: string;
  children: ReactNode;
}) => (
  <div className={styles.item}>
    <h2>{props.title}</h2>
    <main>{props.children}</main>
  </div>
);

export default TournamentBanner;
